// extracted by mini-css-extract-plugin
export var postDetails = "PostIntro-module--postDetails--PBOZ4";
export var postImage = "PostIntro-module--postImage--6tzT8";
export var postIntro = "PostIntro-module--postIntro--9eQPT";
export var published = "PostIntro-module--published--l7-WY";
export var tags = "PostIntro-module--tags--U9wPo";
export var title = "PostIntro-module--title--wYkd1";